import React from 'react';

interface AlertIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number | string;
  color?: string;
}

const AlertIcon: React.FC<AlertIconProps> = ({
  size = 26,
  color = '#0098D9',
  ...props
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.1151 16.5664H12.8849V13.7475H16.1161V12.2106H12.8849V9.40467H11.1151V12.2106H7.88394V13.7475H11.1151V16.5664ZM0.300003 22.2822V20.7453H3.12009V10.0458C3.12009 8.21151 3.76112 6.57581 5.04318 5.13868C6.32498 3.70156 7.99392 2.81061 10.05 2.46583V1.77933C10.05 1.30902 10.2394 0.909152 10.6182 0.579731C10.9971 0.250536 11.457 0.0859375 11.9981 0.0859375C12.5394 0.0859375 13 0.250536 13.3798 0.579731C13.7599 0.909152 13.95 1.30902 13.95 1.77933V2.47227C16.0061 2.81275 17.675 3.70156 18.9568 5.13868C20.2389 6.57581 20.8799 8.21151 20.8799 10.0458V20.7453H23.7V22.2822H0.300003ZM11.9973 26.0859C11.2212 26.0859 10.5577 25.8462 10.0067 25.3666C9.45551 24.887 9.17991 24.3105 9.17991 23.637H14.8201C14.8201 24.3127 14.5437 24.8898 13.991 25.3683C13.4382 25.8467 12.7736 26.0859 11.9973 26.0859ZM4.88991 20.7453H19.1101V10.0458C19.1101 8.33502 18.4176 6.87824 17.0326 5.67549C15.6475 4.47273 13.97 3.87135 12 3.87135C10.03 3.87135 8.35246 4.47273 6.96744 5.67549C5.58242 6.87824 4.88991 8.33502 4.88991 10.0458V20.7453Z"
        fill={color}
      />
    </svg>
  );
};

export default AlertIcon;
